module.exports = __webpack_public_path__ + "static/media/rick.ab57f5b7.png";